const DiscordIcon = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1316 4.00639C11.2972 3.6288 10.411 3.3536 9.48603 3.2C9.36953 3.3984 9.24018 3.66719 9.14964 3.8784C8.16578 3.73759 7.18901 3.73759 6.21873 3.8784C6.12817 3.66719 5.99232 3.3984 5.88235 3.2C4.9509 3.3536 4.0647 3.6288 3.23609 4.00639C1.56074 6.45119 1.10794 8.83838 1.33434 11.1936C2.44692 11.9935 3.52071 12.48 4.57573 12.8C4.83447 12.4544 5.06734 12.0832 5.26787 11.6928C4.88622 11.552 4.52399 11.3792 4.17469 11.1744C4.26524 11.1104 4.35581 11.04 4.4399 10.9696C6.54864 11.9232 8.83266 11.9232 10.9156 10.9696C11.0061 11.04 11.0902 11.1104 11.1807 11.1744C10.8314 11.3792 10.4692 11.552 10.0875 11.6928C10.2881 12.0832 10.521 12.4544 10.7797 12.8C11.8341 12.48 12.9143 11.9935 14.0211 11.1936C14.2992 8.46722 13.5806 6.09921 12.1316 4.00639ZM5.55895 9.74078C4.92502 9.74078 4.40754 9.1712 4.40754 8.47358C4.40754 7.77602 4.91209 7.20638 5.55895 7.20638C6.19932 7.20638 6.72326 7.77602 6.71032 8.47358C6.71032 9.1712 6.19932 9.74078 5.55895 9.74078ZM9.80944 9.74078C9.17548 9.74078 8.65735 9.1712 8.65735 8.47358C8.65735 7.77602 9.16256 7.20638 9.80944 7.20638C10.4498 7.20638 10.9738 7.77602 10.9608 8.47358C10.9608 9.1712 10.4563 9.74078 9.80944 9.74078Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DiscordIcon;
